import React, { useState, useEffect } from 'react';

const FasceOrarie = ({ onFasceOrarieChange, initialFasceOrarie = [] }) => {
  const [fasceOrarie, setFasceOrarie] = useState([]);

  const [fasciaInizio, setFasciaInizio] = useState('');
  const [fasciaFine, setFasciaFine] = useState('');

  // Caricamento iniziale delle fasce dal prop
  useEffect(() => {
    if (initialFasceOrarie && initialFasceOrarie.length > 0) {
      // Se già in formato stringa "HH:MM - HH:MM"
      if (typeof initialFasceOrarie[0] === 'string') {
        setFasceOrarie(initialFasceOrarie);
      } else {
        // Se in formato oggetto { inizio, fine }
        const convertite = initialFasceOrarie.map(f => `${f.inizio} - ${f.fine}`);
        setFasceOrarie(convertite);
      }
    }
  }, [initialFasceOrarie]);

  // Comunica ogni volta che cambiano
  useEffect(() => {
    onFasceOrarieChange(fasceOrarie);
  }, [fasceOrarie, onFasceOrarieChange]);

  const handleAddFasciaOraria = () => {
    if (fasciaInizio && fasciaFine) {
      const nuovaFascia = `${fasciaInizio} - ${fasciaFine}`;
      const nuoveFasceOrarie = [...fasceOrarie, nuovaFascia];
      setFasceOrarie(nuoveFasceOrarie);
      setFasciaInizio('');
      setFasciaFine('');
    }
  };

  const handleRemoveFasciaOraria = (index) => {
    const nuoveFasceOrarie = fasceOrarie.filter((_, i) => i !== index);
    setFasceOrarie(nuoveFasceOrarie);
  };

  return (
    <div>
      <h3>Aggiungi Fasce Orarie</h3>
      <label>
        Inizio:
        <input
          type="time"
          value={fasciaInizio}
          onChange={(e) => setFasciaInizio(e.target.value)}
        />
      </label>
      <label>
        Fine:
        <input
          type="time"
          value={fasciaFine}
          onChange={(e) => setFasciaFine(e.target.value)}
        />
      </label>
      <button type="button" onClick={handleAddFasciaOraria}>
        Aggiungi Fascia Oraria
      </button>
      <ul>
        {fasceOrarie.map((fascia, index) => (
          <li key={index}>
            {fascia}{' '}
            <button type="button" onClick={() => handleRemoveFasciaOraria(index)}>
              Rimuovi
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FasceOrarie;
